import { DispatchItem } from './../dispatchitem/dispatchitem';
import { LogEventService } from './../logevent/logeventservice';
import { Component, OnInit } from '@angular/core';
import { Ticket } from '../ticket/ticket';
import { DispatchOrder } from '../dispatch-order/dispatch-order';
import { Tracking } from '../tracking/tracking';
import { Logevent } from '../logevent/logevent';
import { TicketService } from '../ticket/ticketService';
import { DispatchItemService } from '../dispatchitem/dispatchitemservice';
import { DispatchOrderService } from '../dispatch-order/dispatch-order-service';
import { TrackingService } from '../tracking/trackingservice';
import { forkJoin } from 'rxjs';
import { Machine } from '../machine/machine';
import { MachineService } from '../machine/machineService';
@Component({
  selector: 'app-bossfnc',
  templateUrl: './bossfnc.component.html',
  styleUrls: ['./bossfnc.component.css', '../app.component.less']
})
export class BossfncComponent implements OnInit {

_tickets : Ticket[] ; 
_dispatchOrders : DispatchOrder[];
_dispatchItems : DispatchItem [] ; 
_trackings : Tracking []; 
_events : Logevent[]; 
_machines : Machine[];

  isLoading = false;
  constructor(private ts : TicketService, 
    private dis : DispatchItemService, 
    private dos : DispatchOrderService, 
    private trs : TrackingService, 
    private logservice : LogEventService,
    private machineservice : MachineService
  ) { }
  
  ngOnInit(): void {
  
this.runLoadScripts();
  
  }


  async runLoadScripts() {
    this.isLoading = true; // Show the spinner
   try {
      await this.getAllElements(); // Simulate long-running function
    } catch (error) {
      console.error('Error during the operation:', error);
    } finally {
      this.isLoading = false; // Hide the spinner
      console.table (this._dispatchItems);
      console.table( this._dispatchOrders);
      console.table (this._tickets);
      console.table(this._events);
      console.table(this._trackings);
      console.table (this._machines);
      console.log("HELLO WORLED");
    }
  }

  
getAllElements(): Promise<void> {
  return new Promise((resolve, reject) => {
    forkJoin({
      dispatchOrders: this.dos.getDispatchOrders(),
      dispatchItems: this.dis.getDispatchItems(),
      trackings: this.trs.gettrackings(),
      tickets: this.ts.getTicketes(),
      logEvents: this.logservice.getLogEvents(),
      machines: this.machineservice.getMachines()
    }).subscribe({
      next: (results) => {
        this._dispatchOrders = results.dispatchOrders;
        this._dispatchItems = results.dispatchItems;
        this._trackings = results.trackings;
        this._tickets = results.tickets;
        this._events = results.logEvents;
        this._machines = results.machines;
        resolve(); // Resolve the promise after setting all data
      },
      error: (err) => {
        console.error('Error fetching data:', err);
        reject(err); // Reject the promise if any observable fails
      },
    });
  });
}

async runBulkDelete() {
      this.isLoading = true; // Show the spinner
     try {
        await this.bulkDelete(); // Simulate long-running function
      } catch (error) {
        console.error('Error during the operation:', error);
      } finally {
        this.isLoading = false; // Hide the spinner
      }
    }
  
    bulkDelete(): Promise<void> {
      return new Promise((resolve, reject) => {
        // Collect all delete operations in a single array
        const ticketDeletes = this._tickets.map(ticket => this.ts.deleteTicket(ticket.id).toPromise());
        const trackingDeletes = this._trackings.map(tracking => this.trs.deleteTracking(tracking.id).toPromise());
        const orderDeletes = this._dispatchOrders.map(order => this.dos.deleteDispatchOrder(order.id).toPromise());
        const itemDeletes = this._dispatchItems.map(item => this.dis.deleteDisppatchItem(item.id).toPromise());
        const eventDeletes = this._events.map(event => this.logservice.deleteLogevent(event.id).toPromise());
        const machinesUpds = this._machines.map(machine => this.machineservice.changeState(machine.id, 1).toPromise());
        const machineDeletes = this._machines.map(machine => this.machineservice.deleteMachine(machine.id).toPromise() )
    
        // Use concat to combine arrays
        const allDeletes = ticketDeletes
          .concat(trackingDeletes)
          .concat(orderDeletes)
          .concat(itemDeletes)
          .concat(eventDeletes)
          .concat(machinesUpds)
          .concat(machineDeletes);

    
        // Use Promise.all to execute all delete operations
        Promise.all(allDeletes)
          .then(() => {
            console.log('All items deleted successfully');
            resolve(); // Resolve the main promise
          })
          .catch(error => {
            console.error('Error occurred during bulk deletion:', error);
            reject(error); // Reject the main promise if any delete fails
          });
      });
    }
    
  
  }

